import React, { useState, useEffect } from 'react';
import '../styles/treeform.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import API_URL from "../config/api";

function TreeForm() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(1);
  const [treeId, setTreeId] = useState('');
  const [name, setName] = useState('');
  const [scientificName, setScientificName] = useState('');
  const [description, setDescription] = useState('');
  const [otherNames, setOtherNames] = useState('');
  const [treeCycle, setTreeCycle] = useState('');
  const [fruitingMonths, setFruitingMonths] = useState('');
  const [treeStatus, setTreeStatus] = useState('');
  const [treeSpecies, setTreeSpecies] = useState('');
  const [fruitColor, setFruitColor] = useState('');
  const [pestIdentified, setPestIdentified] = useState('');
  const [floweringDescription, setFloweringDescription] = useState('');
  const [fruitingDescription, setFruitingDescription] = useState('');
  const [unripeFruitDescription, setUnripeFruitDescription] = useState('');
  const [ripeFruitDescription, setRipeFruitDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Assuming you will handle file inputs as well
  const [treeImage, setTreeImage] = useState(null);
  const [floweringImage, setFloweringImage] = useState(null);
  const [fruitingImage, setFruitingImage] = useState(null);
  const [unripeFruitImage, setUnripeFruitImage] = useState(null);
  const [ripeFruitImage, setRipeFruitImage] = useState(null);

  const steps = 4;
  const [error, setError] = useState('');
  const containerStyle = {
    width: '80%',
    border: '1px solid #ccc',
    padding: '50px',
    marginTop: '5%',
    backgroundColor: 'white',
  };
  const [formValid, setFormValid] = useState(false);

  // Function to check if all required fields are filled
  const checkFormValidity = () => {
    // Check if all required fields have values
    const requiredFields = [treeId, name, scientificName, description];
    const isValid = requiredFields.every(field => field.trim() !== '');
    setFormValid(isValid);
  };

  // Run checkFormValidity whenever any of the form fields change
  useEffect(() => {
    checkFormValidity();
  }, [treeId, name, scientificName, description]);

  const next = () => {
    if (formValid) {
      setCurrent(current + 1);
    } else {
      toast.error('Please fill all required fields');
    }
  };

  const previous = () => {
    setCurrent(current - 1);
  };


  const submit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      try{
          const formData=new FormData();
          formData.append("speciesid",treeId);
          formData.append("name",name);
          formData.append("scientificname",scientificName);
          formData.append("description",description);
          formData.append("othernames",otherNames);
          formData.append("treecycle",treeCycle);
          formData.append("fruitingmonths",fruitingMonths);
          formData.append("treestatus",treeStatus);
          formData.append("treespecies",treeSpecies);
          formData.append("fruitcolour",fruitColor);
          formData.append("pestidentified",pestIdentified);
          formData.append("floweringdescription",floweringDescription);
          formData.append("fruitingdescription",fruitingDescription);
          formData.append("unripefruitdescription",unripeFruitDescription);
          formData.append("ripefruitdescription",ripeFruitDescription);

          if(treeImage)
              formData.append("treeImage",treeImage);
          if(floweringImage)
              formData.append("floweringImage",floweringImage);
          if(fruitingImage)
              formData.append("fruitingImage",fruitingImage);
          if(unripeFruitImage)
              formData.append("unripeFruitImage",unripeFruitImage);
          if(ripeFruitImage)
              formData.append("ripeFruitImage",ripeFruitImage);

            const response=await fetch(`${API_URL}/admin/trees/save_tree.php`,

            {
              method:"POST",
              body:formData
            }
          );
          const result=await response.json();
          if(result.success){
              toast.success("Tree saved successfully.");
              setTimeout(()=>{navigate(`/TreeInfo?treeId=${treeId}`);
              },2000);
          }else{
              toast.error(result.message);
          }
      }catch(err){
          console.error(err);
          toast.error("Server Error");
      }
      setIsLoading(false);
  };

  const setProgressBar = (curStep) => {
    const percent = ((curStep - 1) / (steps - 1)) * 100;
    return percent + '%';
  };

  return (
    <Container style={containerStyle}>
      <Row>
        <Col>
          <div id="heading">Add New Tree Species</div>
          <p id='paragraphh'>Fill all form fields to go to next step</p>
          {isLoading ? (
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
          ) : (
            <form id="msform" onSubmit={submit}>
              <ul id="progressbar">
                <li className={current === 1 ? 'active' : ''}><strong>First</strong></li>
                <li className={current === 2 ? 'active' : ''}><strong>Second</strong></li>
                <li className={current === 3 ? 'active' : ''}><strong>Third</strong></li>
                <li className={current === 4 ? 'active' : ''}><strong>Finish</strong></li>
              </ul>
              <div className="progress">
                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: setProgressBar(current) }} aria-valuemin="0" aria-valuemax="100"></div>
              </div>

              <br />

              {current === 1 && (
                <fieldset>
                  <div className="form-card">
                    <label htmlFor="tree-id">TreeId:</label>
                    <input type="text" className="fieldlabels" id="tree-id" value={treeId} onChange={e => setTreeId(e.target.value)} placeholder="Tree ID: Example (FIT-AB01)" />
                    <label htmlFor="name">Name:</label>
                    <input type="text" className="fieldlabels" id="name" value={name} onChange={e => setName(e.target.value)} placeholder="Name" />
                    <label htmlFor="scientificName">Scientific Name:</label>
                    <input type="text" className="fieldlabels" id="scientificName" value={scientificName} onChange={e => setScientificName(e.target.value)} placeholder="Scientific Name" required />
                    <label htmlFor="description">Description:</label>
                    <input type="text" className="fieldlabels" id="description" value={description} onChange={e => setDescription(e.target.value)} placeholder="Description" required />
                    <label htmlFor="otherNames">Other Names (separate by comma):</label>
                    <input type="text" className="fieldlabels" id="otherNames" value={otherNames} onChange={e => setOtherNames(e.target.value)} placeholder="Other Names" />
                    <label className="fieldlabels">Tree Image:</label>
                    <input type="file" id="treeImage" onChange={e => setTreeImage(e.target.files[0])} accept="image/*" />
                  </div>
                  <button type="button" className="next action-button" onClick={next}>Next</button>
                </fieldset>
              )}

              {current === 2 && (
                <fieldset>
                  <div className="form-card">
                    <label htmlFor="treeCycle">Tree Cycle:</label>
                    <select className="form-control" id="treeCycle" value={treeCycle} onChange={e => setTreeCycle(e.target.value)} required>
                      <option value="">Select</option>
                      <option value="Annual">Annual</option>
                      <option value="Biennial">Biennial</option>
                      <option value="Perennial">Perennial</option>
                    </select>
                    <label htmlFor="fruitingMonths">Fruiting Months:</label>
                    <input type="text" className="fieldlabels" id="fruitingMonths" value={fruitingMonths} onChange={e => setFruitingMonths(e.target.value)} />
                    <label htmlFor="treeStatus">Tree Status:</label>
                    <select className="form-control" id="treeStatus" value={treeStatus} onChange={e => setTreeStatus(e.target.value)} required>
                      <option value="">Select</option>
                      <option value="Healthy">Healthy</option>
                      <option value="Fruiting">Fruiting</option>
                      <option value="Matured">Matured</option>
                      <option value="Infected">Infected</option>
                      <option value="Unknown">Unknown</option>
                    </select>
                    <label htmlFor="treeSpecies">Tree Species:</label>
                    <select className="form-control" id="treeSpecies" value={treeSpecies} onChange={e => setTreeSpecies(e.target.value)} required>
                      <option value="">Select</option>
                      <option value="Indigenous Fruit Tree">Indigenous Fruit Tree</option>
                      <option value="Indigenous Forest Tree">Indigenous Forest Tree</option>
                    </select>
                    <label htmlFor="fruitColor">Fruit Color:</label>
                    <input type="color" className="fieldlabels" id="fruitColor" value={fruitColor} onChange={e => setFruitColor(e.target.value)} placeholder="Fruit Color" />


                  </div>
                  <button type="button" className="next action-button" onClick={next}>Next</button>
                  <button type="button" className="previous action-button-previous" onClick={previous}>Previous</button>
                </fieldset>
              )}

              {current === 3 && (
                <fieldset>
                  <div className="form-card">
                    <label htmlFor="pestIdentified">Pest Identified:</label>
                    <input type="text" id="pestIdentified" value={pestIdentified} onChange={e => setPestIdentified(e.target.value)} required placeholder="Pest Identified" />
                    <label htmlFor="floweringDescription">Flowering Description:</label>
                    <textarea id="floweringDescription" value={floweringDescription} onChange={e => setFloweringDescription(e.target.value)} rows="4" required placeholder="Description"></textarea>
                    <label htmlFor="floweringImage">Choose Flowering Picture:</label>
                    <input type="file" id="floweringImage" onChange={e => setFloweringImage(e.target.files[0])} accept="image/*" required />
                  </div>
                  <button type="button" className="next action-button" onClick={next}>Next</button>
                  <button type="button" className="previous action-button-previous" onClick={previous}>Previous</button>
                </fieldset>
              )}

              {current === 4 && (
                <fieldset>
                  <div className="form-card">
                    <label htmlFor="fruitingDescription">Fruiting Description:</label>
                    <textarea id="fruitingDescription" value={fruitingDescription} onChange={e => setFruitingDescription(e.target.value)} rows="4" required placeholder="Description"></textarea>
                    <label htmlFor="fruitingImage">Choose Fruiting Picture:</label>
                    <input type="file" id="fruitingImage" onChange={e => setFruitingImage(e.target.files[0])} accept="image/*" required />
                    <label htmlFor="unripeFruitDescription">Unripe Fruit Description:</label>
                    <textarea id="unripeFruitDescription" value={unripeFruitDescription} onChange={e => setUnripeFruitDescription(e.target.value)} rows="4" required placeholder="Description"></textarea>
                    <label htmlFor="unripeFruitImage">Choose Unripe Fruit Picture:</label>
                    <input type="file" id="unripeFruitImage" onChange={e => setUnripeFruitImage(e.target.files[0])} accept="image/*" required />
                    <label htmlFor="ripeFruitDescription">Ripe Fruit Description:</label>
                    <textarea id="ripeFruitDescription" value={ripeFruitDescription} onChange={e => setRipeFruitDescription(e.target.value)} rows="4" required placeholder="Description"></textarea>
                    <label htmlFor="ripeFruitImage">Choose Ripe Fruit Picture:</label>
                    <input type="file" id="ripeFruitImage" onChange={e => setRipeFruitImage(e.target.files[0])} accept="image/*" required />
                  </div>
                  <button type="submit" className="action-button">Submit</button>
                  <button type="button" className="previous action-button-previous" onClick={previous}>Previous</button>
                </fieldset>
              )}
            </form>
          )}
        </Col>
      </Row>
      {error && <p className="error">{error}</p>}
      <ToastContainer position="top-center" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </Container>
  );
}

export default TreeForm;